import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, FolderOpen, Users, FileText } from 'lucide-react';
import { Sidebar as AlumaSidebar, useSidebar } from '@ntconsult/aluma-react';
import { useAuth } from '@features/auth';

interface MenuItem {
  icon: React.ElementType;
  labelKey: 'home' | 'files' | 'users' | 'audit';
  path: string;
  end?: boolean;
  roles?: string[];
}

const menuItems: MenuItem[] = [
  { icon: Home, labelKey: 'home', path: '/', end: true },
  { icon: FolderOpen, labelKey: 'files', path: '/files' },
  { icon: Users, labelKey: 'users', path: '/users', roles: ['admin'] },
  { icon: FileText, labelKey: 'audit', path: '/audit', roles: ['admin', 'manager'] },
];

export function Sidebar() {
  const { t } = useTranslation('common');
  const { user } = useAuth();
  const { pathname } = useLocation();
  const { isMobile, setOpen } = useSidebar();

  const filteredItems = menuItems.filter(
    (item) => !item.roles || (user && item.roles.includes(user.role))
  );

  const handleNavClick = () => {
    if (isMobile) setOpen(false);
  };

  const labels: Record<MenuItem['labelKey'], string> = {
    home: t('sidebar.home', 'Início'),
    files: t('sidebar.files', 'Arquivos'),
    users: t('sidebar.users', 'Usuários'),
    audit: t('sidebar.audit', 'Auditoria'),
  };

  const isActive = (item: MenuItem) =>
    item.end ? pathname === item.path : pathname === item.path || pathname.startsWith(`${item.path}/`);

  return (
    <AlumaSidebar ariaLabel={t('sidebar.label', 'Navegação principal')}>
      <AlumaSidebar.Nav>
        {filteredItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          return (
            <AlumaSidebar.Item
              key={item.path}
              asChild
              icon={<Icon aria-hidden />}
              active={active}
            >
              <NavLink to={item.path} end={item.end} onClick={handleNavClick}>
                {labels[item.labelKey]}
              </NavLink>
            </AlumaSidebar.Item>
          );
        })}
      </AlumaSidebar.Nav>
    </AlumaSidebar>
  );
}
